import { Component, OnInit } from "@angular/core";
import { makeStateKey, Meta, TransferState } from "@angular/platform-browser";

import { ISubSection } from "pf_styleguide/src/patterns/organisms/sub-section/sub-section.interface";
import { combineLatest as observableCombineLatest } from "rxjs";

import { ConfigureService } from "../configure/configure.service";
import { BlogService } from "../shared/blog.service";
import { Blog } from "../shared/model/blogs";
import { SOCIAL } from "./../static/static.data.social";

// make state key in state to store users
const BLOGSPOPULAR = makeStateKey<any>("blogsPopular");
const BLOGSFEATURED = makeStateKey<any>("blogsFeatured");

@Component({
    selector: "mlp-blog",
    templateUrl: "./blog.component.html",
    styleUrls: ["./blog.component.scss"],
})
export class BlogComponent implements OnInit {
    subNav: ISubSection;
    dropdownIsOpen: boolean;
    readonly SOCIAL = SOCIAL;

    constructor(
        private blogService: BlogService,
        private meta: Meta,
        private transferState: TransferState,
        private config: ConfigureService
    ) {
        const EXISTBLOGPOPULAR = this.transferState.get(
            BLOGSPOPULAR,
            [] as Array<Blog>
        );
        const EXISTBLOGFEATURED = this.transferState.get(
            BLOGSFEATURED,
            [] as Array<Blog>
        );

        if (EXISTBLOGPOPULAR.length)
            this.blogService.blogsPopular = EXISTBLOGPOPULAR;
        if (EXISTBLOGFEATURED.length)
            this.blogService.blogsFeatured = EXISTBLOGFEATURED;
    }

    ngOnInit(): void {
        observableCombineLatest(
            this.blogService.callBlogPopular(),
            this.blogService.callBlogFeatured(),
            this.blogService.callBlogCategories(),
            (popular, featured, categories) => ({
                popular,
                featured,
                categories,
            })
        ).subscribe((data) => {
            this.blogService.blogsPopular = data.popular;
            this.blogService.blogsFeatured = data.featured;
            this.blogService.categories = data.categories;
            this.blogService.categoriesLoadedEvent.emit(data.categories);

            if (!this.subNav) {
                this.subNav = {
                    title: "Blog",
                    subNavLinks: this.blogService.blogMenuLinks,
                    nav: {
                        mainLinks: [
                            {
                                name: "Home",
                                url: "/blog",
                            },
                            {
                                name: "Football",
                                url: "category/football",
                            },
                            {
                                name: "Grassroots sport",
                                url: "category/grassroots-sport",
                            },
                        ],
                        dropdownLinks: true,
                        routerLinkActiveOptions: true,
                    },
                };
            }

            this.transferState.set(
                BLOGSPOPULAR,
                this.blogService.stripOutScriptTagsCollection(data.popular)
            );
            this.transferState.set(
                BLOGSFEATURED,
                this.blogService.stripOutScriptTagsCollection(data.featured)
            );
        });

        this.updateMetaData();
    }

    dropdownStatus(status): void {
        this.dropdownIsOpen = status;
    }

    private updateMetaData(): void {
        const metaKeywords =
            "Playfinder, blog, sports, grasroots, things to do";

        this.meta.addTag({
            property: "article:publisher",
            content: this.config.params.facebookUrl,
        });
        this.meta.addTag({ property: "og:locale", content: "en_GB" });
        this.meta.addTag({ property: "og:type", content: "website" });
        this.meta.addTag({
            property: "og:image",
            content: "/ng-assets/blog/thumbnail-v1.jpg",
        });
        this.meta.addTag({ property: "og:site_name", content: "Playfinder" });
        this.meta.addTag({ property: "og:title", content: "" }); // dynamic
        this.meta.addTag({ property: "og:description", content: "" }); // dynamic
        this.meta.addTag({
            property: "og:url",
            content: `${this.config.params.canonicalDomain}/blog`,
        });
        this.meta.addTag({
            property: "twitter:card",
            content: "summary_large_image",
        });
        this.meta.addTag({
            property: "twitter:site",
            content: SOCIAL.twitterhandler,
        });
        this.meta.addTag({ property: "twitter:title", content: "" }); // dynamic
        // tslint:disable-next-line:max-line-length
        this.meta.addTag({
            property: "twitter:image",
            content: `${this.config.params.canonicalDomain}/ng-assets/blog/thumbnail-v1.jpg`,
        }); // dynamic
        this.meta.updateTag({ name: "keywords", content: metaKeywords });
    }
}
